import React, { Component } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Avatar,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  Print,
  Usb,
  Bluetooth,
  Router,
  Bolt,
  Speed,
  SettingsInputComponent,
  Restaurant,
  ReceiptLong,
  ExpandMore,
  CheckCircle,
  ArrowForward,
  PhonelinkSetup,
  CheckCircleOutline,
  Build
} from '@mui/icons-material';

class FazPedidoSolucaoImpressaoPage extends Component {
  render() {
    return (
      <Box sx={{ bgcolor: '#ffffff', color: '#0f172a', minHeight: '100vh', pb: 10 }}>

        {/* 1. HERO SECTION */}
        <Box
          sx={{
            bgcolor: '#ffffff',
            pt: { xs: 8, md: 12 },
            pb: { xs: 8, md: 10 },
            borderBottom: '1px solid #f1f5f9'
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={4} alignItems="center">
              <Grid size={{ xs: 12, md: 7 }}>
                <Chip
                  label="Soluções de Hardware & Automação"
                  sx={{
                    bgcolor: 'rgba(124, 58, 237, 0.1)',
                    color: '#7c3aed',
                    fontWeight: 700,
                    mb: 2,
                    px: 1
                  }}
                />
                <Typography
                  variant="h2"
                  component="h1"
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: '2.2rem', md: '3.4rem' },
                    lineHeight: 1.2,
                    color: '#0f172a',
                    mb: 2
                  }}
                >
                  Impressão Térmica Automática{' '}
                  <Box component="span" sx={{ color: '#7c3aed' }}>
                    sem telas de confirmação
                  </Box>
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ color: '#64748b', fontWeight: 400, mb: 4, lineHeight: 1.6 }}
                >
                  Disparo instantâneo de comandas para a cozinha, bar e balcão. Conectividade direta via USB, Bluetooth ou Rede (IP) em bobinas de 58mm e 80mm usando protocolo ESC/POS nativo.
                </Typography>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Button
                    variant="contained"
                    size="large"
                    endIcon={<ArrowForward />}
                    sx={{
                      bgcolor: '#7c3aed',
                      '&:hover': { bgcolor: '#6d28d9' },
                      px: 4,
                      py: 1.8,
                      fontSize: '1.1rem',
                      fontWeight: 700,
                      borderRadius: '12px',
                      textTransform: 'none',
                      boxShadow: '0 10px 25px -5px rgba(124, 58, 237, 0.3)'
                    }}
                  >
                    Testar Impressão Silenciosa
                  </Button>
                  <Button
                    variant="outlined"
                    size="large"
                    sx={{
                      color: '#7c3aed',
                      borderColor: '#7c3aed',
                      '&:hover': { borderColor: '#6d28d9', bgcolor: 'rgba(124, 58, 237, 0.04)' },
                      px: 3,
                      py: 1.8,
                      borderRadius: '12px',
                      textTransform: 'none',
                      fontWeight: 700
                    }}
                  >
                    Ver Guia de Configuração
                  </Button>
                </Stack>
              </Grid>

              {/* DEMO DE COMANDA EM IMPRESSÃO */}
              <Grid size={{ xs: 12, md: 5 }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    bgcolor: '#f8fafc',
                    borderRadius: '24px',
                    border: '2px solid #7c3aed',
                    boxShadow: '0 20px 30px -10px rgba(124, 58, 237, 0.15)'
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <Avatar sx={{ bgcolor: '#7c3aed', mr: 2, width: 48, height: 48 }}>
                      <Print />
                    </Avatar>
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>
                        SoPedePrint Driver / WebSocket
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#64748b' }}>
                        Serviço Ativo na Porta Local 41520
                      </Typography>
                    </Box>
                  </Box>

                  <Card variant="outlined" sx={{ mb: 2, borderRadius: '14px', borderColor: '#cbd5e1', bgcolor: '#ffffff' }}>
                    <CardContent sx={{ p: 2, fontFamily: 'monospace', '&:last-child': { pb: 2 } }}>
                      <Typography variant="caption" sx={{ color: '#64748b', display: 'block', mb: 1, textTransform: 'uppercase', fontWeight: 700 }}>
                        *** PEDIDO COZINHA #1084 ***
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 800, color: '#0f172a' }}>
                        1x X-TUDO ESPECIAL
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#dc2626', display: 'block' }}>
                        - Sem Cebola / Molho Extra
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 800, color: '#0f172a', mt: 1 }}>
                        1x COCA-COLA 2L
                      </Typography>
                      <Box sx={{ borderTop: '1px dashed #cbd5e1', mt: 1.5, pt: 1, display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="caption" sx={{ fontWeight: 700 }}>MESA 04</Typography>
                        <Typography variant="caption" sx={{ color: '#7c3aed', fontWeight: 700 }}>IMPRESSO AUTO</Typography>
                      </Box>
                    </CardContent>
                  </Card>

                  <Box sx={{ bgcolor: '#ffffff', p: 2, borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <CheckCircle sx={{ color: '#7c3aed', fontSize: 20 }} />
                      <Typography variant="body2" sx={{ fontWeight: 600, color: '#334155' }}>
                        Comandos brutos ESC/POS para corte e gaveta automáticos.
                      </Typography>
                    </Stack>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </Box>

        {/* 2. OS 4 PILARES DA IMPRESSÃO */}
        <Container maxWidth="lg" sx={{ mt: 10 }}>
          <Grid container spacing={3}>
            {[
              {
                num: '01',
                title: 'Impressão Silenciosa e Direta',
                desc: 'Disparo sem abrir telas de diálogo do navegador. O pedido cai no sistema e a comanda sai na impressora.',
                icon: <Bolt sx={{ color: '#7c3aed', fontSize: 32 }} />
              },
              {
                num: '02',
                title: 'Multi-setores (Cozinha & Bar)',
                desc: 'Roteamento inteligente de itens: bebidas saem no bar, pratos principais na cozinha e cupom no balcão.',
                icon: <Restaurant sx={{ color: '#7c3aed', fontSize: 32 }} />
              },
              {
                num: '03',
                title: 'Formatos 58mm & 80mm',
                desc: 'Layouts otimizados para bobinas estreitas ou largas com formatação visual limpa e caracteres legíveis.',
                icon: <ReceiptLong sx={{ color: '#7c3aed', fontSize: 32 }} />
              },
              {
                num: '04',
                title: 'Multi-conexões de Hardware',
                desc: 'Suporte a portas de impressora local (/dev/usb/lp0, COM, LPT), rede Ethernet/Wi-Fi e Bluetooth.',
                icon: <SettingsInputComponent sx={{ color: '#7c3aed', fontSize: 32 }} />
              }
            ].map((pillar, idx) => (
              <Grid size={{ xs: 12, sm: 6, md: 3 }} key={idx}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    height: '100%',
                    borderRadius: '16px',
                    bgcolor: '#f8fafc',
                    border: '1px solid #e2e8f0',
                    position: 'relative',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      borderColor: '#7c3aed',
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 20px -5px rgba(124, 58, 237, 0.1)'
                    }
                  }}
                >
                  <Typography variant="h3" sx={{ fontWeight: 900, color: 'rgba(124, 58, 237, 0.2)', position: 'absolute', top: 16, right: 16 }}>
                    {pillar.num}
                  </Typography>
                  <Box sx={{ mb: 2 }}>{pillar.icon}</Box>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a', mb: 1 }}>
                    {pillar.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b', lineHeight: 1.6 }}>
                    {pillar.desc}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* 3. CONECTIVIDADE E ARQUITETURA */}
        <Container maxWidth="lg" sx={{ mt: 12 }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 4, md: 6 },
              borderRadius: '24px',
              bgcolor: '#f8fafc',
              border: '1px solid #e2e8f0'
            }}
          >
            <Grid container spacing={4} alignItems="center">
              <Grid size={{ xs: 12, md: 6 }}>
                <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a', mb: 2 }}>
                  Conecte qualquer impressora térmica ao seu FazPedido
                </Typography>
                <Typography variant="body1" sx={{ color: '#475569', mb: 3 }}>
                  Nossa tecnologia comunica diretamente com o hardware do seu estabelecimento usando a ponte de impressão SoPedePrint via WebSockets ou conexão serial/USB nativa.
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b', mb: 4 }}>
                  Mesmo se você utiliza sistemas operacionais Linux ou Windows, o envio de sequências de bytes ESC/POS garante velocidade máxima e suporte a acionamento de guilhotina e gavetas de dinheiro.
                </Typography>

                <Grid container spacing={2}>
                  {[
                    { title: 'Conexão USB Local', desc: 'Plug and play direto na porta do computador da caixa.', icon: <Usb /> },
                    { title: 'Rede IP / Ethernet', desc: 'Impressoras instaladas em cozinhas distantes conectadas por cabo ou Wi-Fi.', icon: <Router /> },
                    { title: 'Bluetooth sem Fio', desc: 'Imprima diretamente de tablets e celulares no atendimento de mesa.', icon: <Bluetooth /> },
                    { title: 'Velocidade Extrema', desc: 'Envio imediato sem passar pelo spooler lento do sistema operacional.', icon: <Speed /> }
                  ].map((item, i) => (
                    <Grid size={{ xs: 12, sm: 6 }} key={i}>
                      <Stack direction="row" spacing={1.5} alignItems="flex-start">
                        <Avatar sx={{ bgcolor: '#7c3aed', width: 36, height: 36, mt: 0.5 }}>
                          {React.cloneElement(item.icon, { sx: { fontSize: 20, color: '#fff' } })}
                        </Avatar>
                        <Box>
                          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#0f172a' }}>
                            {item.title}
                          </Typography>
                          <Typography variant="caption" sx={{ color: '#64748b', display: 'block', lineHeight: 1.4 }}>
                            {item.desc}
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <Box
                  sx={{
                    bgcolor: '#ffffff',
                    p: 4,
                    borderRadius: '20px',
                    border: '2px solid #7c3aed',
                    boxShadow: '0 15px 30px -10px rgba(124, 58, 237, 0.12)'
                  }}
                >
                  <Typography variant="h5" sx={{ fontWeight: 800, color: '#7c3aed', mb: 2 }}>
                    Marcas & Equipamentos Suportados
                  </Typography>
                  <List disablePadding>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Elgin (i7, i9, K, VOX)" />
                    </ListItem>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Bematech (MP-4200 TH, MP-2800 TH)" />
                    </ListItem>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Daruma (DR700, DR800)" />
                    </ListItem>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Epson (TM-T20, TM-T20X, TM-T88)" />
                    </ListItem>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Impressoras Térmicas Genéricas 58mm/80mm ESC/POS (Mini Bluetooth/USB)" />
                    </ListItem>
                  </List>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Container>

        {/* 4. RECURSOS ADICIONAIS DA SOLUÇÃO */}
        <Container maxWidth="lg" sx={{ mt: 10 }}>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a' }}>
              Recursos de Impressão Desenhados para a Operação Real
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {[
              {
                icon: <PhonelinkSetup sx={{ fontSize: 32, color: '#7c3aed' }} />,
                title: 'Instalação em 2 Minutos',
                desc: 'Baixe nossa ponte leve SoPedePrint, execute na máquina do caixa e pronto. Comunicação configurada.'
              },
              {
                icon: <CheckCircleOutline sx={{ fontSize: 32, color: '#7c3aed' }} />,
                title: 'Reimpressão com Um Clique',
                desc: 'Comanda rasgou ou perdeu? Reimprima vias de balcão, cozinha ou entrega diretamente do painel com facilidade.'
              },
              {
                icon: <Build sx={{ fontSize: 32, color: '#7c3aed' }} />,
                title: 'Customização de Cabeçalho e Rodapé',
                desc: 'Adicione logo da empresa, mensagem de agradecimento, chave PIX e informações fiscais nas vias do cliente.'
              }
            ].map((extra, eIdx) => (
              <Grid size={{ xs: 12, md: 4 }} key={eIdx}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    height: '100%',
                    borderRadius: '16px',
                    bgcolor: '#f8fafc',
                    border: '1px solid #e2e8f0'
                  }}
                >
                  <Box sx={{ mb: 1.5 }}>{extra.icon}</Box>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a', mb: 1 }}>
                    {extra.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b' }}>
                    {extra.desc}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* 5. PERGUNTAS FREQUENTES (FAQ) */}
        <Container maxWidth="md" sx={{ mt: 10 }}>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography variant="overline" sx={{ color: '#7c3aed', fontWeight: 800, letterSpacing: 1.5 }}>
              DÚVIDAS FREQUENTES
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a' }}>
              Perguntas sobre Impressão Térmica
            </Typography>
          </Box>

          {[
            {
              q: '1. Preciso pagar licença adicional por impressora conectada?',
              a: 'Não! Você pode conectar quantas impressoras forem necessárias na sua rede ou PDV sem custos adicionais.'
            },
            {
              q: '2. Funciona em impressoras Bluetooth portáteis (58mm)?',
              a: 'Sim! Nossas comandes são otimizadas para imprimir perfeitamente tanto em bobinas estreitas de 58mm quanto em bobinas padronizadas de 80mm.'
            },
            {
              q: '3. Como funciona a impressão automática sem abrir a tela do navegador?',
              a: 'Utilizamos o serviço auxiliar local SoPedePrint rodando via WebSocket na porta 41520, permitindo que o navegador envie dados diretamente para a porta USB/Serial da impressora sem abrir caixas de diálogo.'
            },
            {
              q: '4. É possível separar o pedido da cozinha do pedido da bebida?',
              a: 'Sim! Você pode definir regras de roteamento para que itens da categoria bebidas saiam na impressora do bar, enquanto lanches e pratos saem na impressora da cozinha.'
            }
          ].map((faq, fIdx) => (
            <Accordion
              key={fIdx}
              elevation={0}
              sx={{
                mb: 1.5,
                border: '1px solid #e2e8f0',
                borderRadius: '12px !important',
                '&:before': { display: 'none' },
                '&.Mui-expanded': { border: '1px solid #7c3aed' }
              }}
            >
              <AccordionSummary expandIcon={<ExpandMore sx={{ color: '#7c3aed' }} />}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#0f172a' }}>
                  {faq.q}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2" sx={{ color: '#64748b', lineHeight: 1.7 }}>
                  {faq.a}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Container>

        {/* 6. BANNER FINAL DE CONVERSÃO */}
        <Container maxWidth="lg" sx={{ mt: 10 }}>
          <Paper
            elevation={0}
            sx={{
              bgcolor: '#ffffff',
              borderRadius: '28px',
              p: { xs: 5, md: 8 },
              textAlign: 'center',
              border: '3px solid #7c3aed',
              boxShadow: '0 20px 40px -15px rgba(124, 58, 237, 0.25)'
            }}
          >
            <Typography variant="h3" sx={{ fontWeight: 900, color: '#0f172a', mb: 2, fontSize: { xs: '2rem', md: '2.6rem' } }}>
              Zero atraso na cozinha do seu restaurante!
            </Typography>
            <Typography variant="h6" sx={{ color: '#64748b', mb: 4, maxW: '650px', mx: 'auto', fontWeight: 400 }}>
              Automatize o disparo de comandas para suas impressoras térmicas com o FazPedido hoje mesmo.
            </Typography>
            <Button
              variant="contained"
              size="large"
              endIcon={<ArrowForward />}
              sx={{
                bgcolor: '#7c3aed',
                color: '#ffffff',
                '&:hover': { bgcolor: '#6d28d9' },
                px: 5,
                py: 2,
                fontSize: '1.2rem',
                fontWeight: 800,
                borderRadius: '14px',
                textTransform: 'none',
                boxShadow: '0 10px 25px -5px rgba(124, 58, 237, 0.4)'
              }}
            >
              Falar com um Especialista
            </Button>
          </Paper>
        </Container>

      </Box>
    );
  }
}

export default FazPedidoSolucaoImpressaoPage;